<div *ngIf="overviewDiagnosis" class="overlay" (click)="close()"></div>
<div class="card card--box"
     id="proposal-diagnoses"
     [class.disabled]="waitingAPI"
     [class.fullscreen]="isFullScreen"
     [class.collapsed]="isCollapsed">
    <div class="spinner-wrapper" [hidden]="!waitingAPI">
        <div class="spinner">
            <div class="spinner__loading">
                <i></i>
                <i></i>
            </div>
        </div>
    </div>

    <div *ngIf="selectedFeelings && selectedSymptom && selectedFeelings.length > 0"
         [class.animate]="!isViewOnly"
         class="box-shadow symptom-details">
        <perfect-scrollbar #psSymptom>
            <div class="interactive-tasks tasklists--wrapper tasklists--wrapper--symptom card card--box col-md-12"
                 [class.sticky]="!isViewOnly"
                 [class.pt-0]="!isViewOnly">
                <div class="tasklists--wrapper__header"
                     [class.sticky]="!isViewOnly"
                     [style.width]= "!isViewOnly ? 'calc(' + stickyWidth + ' - 12px)' : 'auto'">
                    <i class="btn-close fal fa-times" (click)="closeDetails(isViewOnly)"></i>
                    <h2 class="tasklists--wrapper__title p-0">
                        {{ selectedSymptom['formatted_neutral_name_' + lang] ||  selectedSymptom['name_' + lang] }}
                    </h2>
                </div>

                <div class="row tasklists--wrapper__rating">
                    <div class="col-md-12 tasklists--wrapper__rating__points">
                        <feeling-selection [selectedFeelings]="selectedFeelings" [lang]="lang" [selectedFeeling]="selectedFeeling" [selectionList]="selectionList" [nodeClassList]="nodeClassList" (changeRating)="updateRating($event.selectedFeeling, $event.status, $event.selectedSymptom, $event.isAnamnestic)" (changePrimary)="updatePrimary($event.feeling)"> </feeling-selection>
                    </div>
                </div>

                <div class="row tasklists--wrapper__statement" #symptomStatement>
                    <div class="col-md-12 tasklists--wrapper__statement__label">{{'Statement' | translate }}</div>
                    <ng-container *ngIf="selectedSymptom.have_statement">
                        <ng-container *ngFor="let feeling of selectedFeelings" >
                            <h4 class="tasklists--wrapper__statement__feeling-name col-md-12" *ngIf="selectedFeelings.length > 1">
                                {{ feeling['name_' + lang] }}
                            </h4>
                            <div #statement class="col-md-12 tasklists--wrapper__statement__description"
                                 [innerHTML]="feeling['statement_' + lang] || ''">
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!selectedSymptom.have_statement">
                        <div #statement class="col-md-12 tasklists--wrapper__statement__description">
                            {{ 'Expert Item: No statement was shown.' | translate }}
                        </div>
                    </ng-container>
                </div>

                <hr />

                <div class="row tasklists--wrapper__statement" #symptomQuestion>
                    <div class="col-md-12 tasklists--wrapper__statement__label">{{'Question' | translate }}</div>
                    <div #description class="col-md-12 tasklists--wrapper__statement__description"
                         [innerHTML]="selectedFeelings[0]['question_' + lang] || '' | safeHtml">
                    </div>
                </div>
                <hr />

                <div class="row tasklists--wrapper__statement" 
                    *ngIf="selectedFeelings[0]['definition_' + lang] !== null && selectedFeelings[0]['definition_' + lang] !== '<p>---</p>'">
                    <div class="col-md-3 tasklists--wrapper__statement__label">
                        {{ 'Definition' | translate }}
                    </div>

                    <div #statement class="col-md-12 tasklists--wrapper__statement__description"
                         [innerHTML]="selectedFeelings[0]['definition_' + lang] | safeHtml">
                    </div>
                </div>

                <div class="row tasklists--wrapper__footer">
                </div>
            </div>
        </perfect-scrollbar>
    </div>


    <div *ngIf="!activeCriteria && !activeProposalDiagnosis" class="panel-heading col-md-12 sticky tasklists--wrapper interactive-tasks">
        <div class="tasklists--wrapper__header tasklists sticky {{lang}}">
            <!--    TASK LISTS  -->
            <ul class="nav nav-justified nav-tabs">
                <li class="nav-item" [class.active]="tabSelected === 0" (click)="selectTab(0)"
                    [class.hidden]="!patientService.enableProposal">
                    <a class="nav-link diagnosis" [class.active]="tabSelected === 0"
                       [class.update-count]="countingDiagnosis.review !== toReviewDiagnosis.length && !firstInit">
                            <span class="badge badge-secondary flex-center">
                                {{ 'Diagnose Proposal' | translate }} ({{toReviewDiagnosis.length}})
                            </span>
                    </a>
                </li>
                <li class="nav-item" [class.active]="tabSelected === 3"
                    (click)="selectTab(3);"
                    [class.hidden]="(selectedCurrentQuestionnaire && !selectedCurrentQuestionnaire.archived && selectedCurrentQuestionnaire.step < 4) || (selectedCurrentQuestionnaire && selectedCurrentQuestionnaire.archived && !selectedCurrentQuestionnaire.di_questionnaire.archived && selectedCurrentQuestionnaire.di_questionnaire.step < 3)">
                    <a class="nav-link diagnosis" [class.active]="tabSelected === 3">
                            <span class="badge badge-secondary flex-center">
                                {{ 'Manual' | translate }}
                            </span>
                    </a>
                </li>
                <li class="nav-item" [class.active]="tabSelected === 1" (click)="selectTab(1)">
                    <a class="nav-link diagnosis" [class.active]="tabSelected === 1"
                       [class.update-count]="countingDiagnosis.accept !== acceptedDiagnosis.length && !firstInit">
                            <span class="badge badge-secondary flex-center">
                                {{ 'Current' | translate }} ({{acceptedDiagnosis.length}})
                            </span>
                    </a>
                </li>
                <li class="nav-item" [class.active]="tabSelected === 2" (click)="selectTab(2)">
                    <a class="nav-link diagnosis" [class.active]="tabSelected === 2"
                       [class.update-count]="countingDiagnosis.dismiss !== dismissedDiagnosis.length && !firstInit">
                            <span class="badge badge-secondary flex-center">
                                {{ 'Dismissed' | translate }} ({{dismissedDiagnosis.length}})
                            </span>
                    </a>
                </li>
            </ul>
            <hr/>
        </div>
        <div class="tasklists tasklists--wrapper__content">
            <perfect-scrollbar #ps>
                <tabset #tabs [justified]="true" class="tasklists">
                    <tab (select)="selectTab(0)" class="tasklists--tab" [class.hidden]="!patientService.enableProposal">
                        <ng-container *ngIf="diagnosesProposal && finishedCV">
                            <ng-container *ngTemplateOutlet="filterTemplate; context: {extendFiltered: extendFiltered}"></ng-container>
                            <ng-container *ngFor="let proposal of filteredProposals | slice:0:showInList.review; let i = index;">
                                <ng-container *ngTemplateOutlet="proposalBlock; context: {proposal: proposal}"></ng-container>
                            </ng-container>
                            <div *ngIf="filteredProposals.length > 0 && filteredProposals.length > showInList.review">
                                <span (click)="showInList.review = showInList.review + 10;" class="loadmore">{{ 'Show more' | translate }}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!diagnosesProposal || !finishedCV">
                            <div class="row none-proposal-panel">
                                <div class="col-xs-12 text-xs-center">
                                        <span>
                                            {{ 'You have no Klenico Diagnose Proposals yet, complete the Clinical Validation or add manually.' | translate }}
                                        </span>
                                </div>
                                <div class="col-xs-12 mr-t--sm">
                                    <button type="button" class="btn btn-primary btn-block badge-pill"
                                            (click)="backToCVTab()">
                                        {{ 'Go to Clinical Validation' | translate }}
                                    </button>
                                </div>
                                <div class="col-xs-12 mr-t--sm">
                                    <button type="button" class="btn btn-secondary btn-block badge-pill"
                                            (click)="selectTab(3)">
                                        {{ 'Add diagnose manually' | translate }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </tab>
                    <tab (select)="selectTab(1)" class="tasklists--tab donelist" [ngClass]="''">
                            <ng-container *ngTemplateOutlet="filterTemplate; context: {extendFiltered: extendFiltered}"></ng-container>
                            <ng-container *ngFor="let proposal of filteredProposals | slice:0:showInList.accept; let i = index">
                                <ng-container *ngTemplateOutlet="proposalBlock; context: {proposal: proposal}"></ng-container>
                            </ng-container>
                            <div *ngIf="filteredProposals.length > 0 && filteredProposals.length > showInList.accept">
                                <span (click)="showInList.accept = showInList.accept + 10;" class="loadmore">{{ 'Show more' | translate }}</span>
                            </div>
                    </tab>
                    <tab (select)="selectTab(2)" class="tasklists--tab donelist" [ngClass]="''">
                        <ng-container *ngTemplateOutlet="filterTemplate; context: {extendFiltered: extendFiltered}"></ng-container>
                        <ng-container *ngFor="let proposal of filteredProposals | slice:0:showInList.dismiss; let i = index">
                            <ng-container *ngTemplateOutlet="proposalBlock; context: {proposal: proposal}"></ng-container>
                        </ng-container>
                        <div *ngIf="filteredProposals.length > 0 && filteredProposals.length > showInList.dismiss">
                            <span (click)="showInList.dismiss = showInList.dismiss + 10;" class="loadmore">{{ 'Show more' | translate }}</span>
                        </div>
                    </tab>
                    <tab (select)="selectTab(3)" class="tasklists--tab">
                        <manual-diagnosis-component [patientId]=patientId [closeAfterEdit]="overviewDiagnosis" [currentEditDiagnosis]="currentEditDiagnosis"
                                                    (updateDiagnosis)="overviewDiagnosis ? close() : null;"
                                                    #manualDiagnosis></manual-diagnosis-component>
                    </tab>
                </tabset>
            </perfect-scrollbar>
        </div>
    </div>

    <perfect-scrollbar #ps *ngIf="activeProposalDiagnosis || activeCriteria">
        <!--    Proposal details LEVEL    -->
        <div *ngIf="activeProposalDiagnosis && !activeCriteria"
                class="panel-heading col-md-12 tasklists--wrapper interactive-tasks tasklists--wrapper--domain proposal-details">
            <div class="tasklists--wrapper__header sticky">
                <i class="back fas fa-long-arrow-left col-md-2" (click)="setActiveDiagnosis(false);goBack(true)"></i>
                <div class="col-md-9 tasklists--wrapper__statement__label criteria-name">{{ activeProposalDiagnosis.diagnoses['name_' + lang] }}</div>
                <div class="col-md-3 tasklists--wrapper__statement__label diagnosis-icon pr-0">
                    <i tooltip="{{ 'Highlight symptoms' | translate }}" containerClass="nowrap" placement="bottom" class="fal diagnosis-icon--highlight" [class.active]="activeProposalDiagnosis.highlight" (click)="highlightDiagnosis(activeProposalDiagnosis)"></i>
                    <i tooltip="{{ 'Accept' | translate }}" placement="bottom" class="fal fa-check-circle diagnosis-icon--accept" [class.active]="activeProposalDiagnosis.status === PROPOSAL_ACTION.accept" (click)="setActionProposal(activeProposalDiagnosis, PROPOSAL_ACTION.accept)"></i>
                    <i tooltip="{{ 'Dismiss' | translate }}"placement="bottom" class=" fal fa-times-circle diagnosis-icon--dismiss" [class.active]="activeProposalDiagnosis.status === PROPOSAL_ACTION.dismiss" (click)="setActionProposal(activeProposalDiagnosis, PROPOSAL_ACTION.dismiss)"></i>
                </div>
                <div class="br-clear"></div>
            </div>
            <div class="container pull-left">
                <div class="row mr-t--sm diagnosis-proposal--header">
                    <div class="col-md-3">
                        {{'ICD Code' | translate}}<br/>
                        <span class="diagnosis-code diagnosis-proposal--header__label">{{activeProposalDiagnosis.diagnoses.code}}</span>
                    </div>
                    <div class="col-md-5">
                        {{'Percentage' | translate}}<br/>
                        <span class="percentage pull-left diagnosis-proposal--header__label">
                        {{ld.parseInt(activeProposalDiagnosis.percentage.from)}}
                        <ng-container *ngIf="activeProposalDiagnosis.percentage.from != activeProposalDiagnosis.percentage.to">-{{ld.parseInt(activeProposalDiagnosis.percentage.to)}}</ng-container>
                        %
                    </span>
                        <span class="progress-bar pull-right">
                        <span class="progress-bar__percentage" [style.width]="(100 - ld.parseInt(activeProposalDiagnosis.percentage.from))*0.8 + 'px'"></span>
                    </span>
                    </div>
                    <div class="col-md-4">
                        {{'Domains' | translate}}<br/>
                        <div *ngFor="let domain of activeProposalDiagnosis.related_domain">
                            <span class="diagnosis-proposal--header__label">
                              {{domain['name_' + lang]}}
                            </span>
                            <br />
                        </div>
                    </div>
                </div>
                <div class="row mr-t--sm">
                    <div class="col-md-8 tasklists--wrapper__statement__label diagnosis-header">{{ 'Criteria' | translate }}</div>
                </div>
                <div class="row">
                    <div *ngIf="activeProposalDiagnosis.criterias.length" class="col-md-12 tasklists--wrapper__statement"
                         [class.animate-marked]="activeProposalDiagnosis['passed']">
                        <div class="tasklists--wrapper__rating pt-0">
                            <div class="tasklists--wrapper__rating__points item-block mt-0"
                                 [class.animate-marked]="criteria['passed']"
                                 *ngFor="let criteria of activeProposalDiagnosis.criterias; let i = index">
                                <ng-container *ngIf="criteria.id">
                                    <div (click)="setActiveCriteria(criteria)"
                                         class="col-md-8 pl-0 tasklists--wrapper__rating__list symptom-name">
                                    <span>
                                        {{criteria.criteria_letter}}. {{criteria['criteria_short_text_' + lang]}}
                                    </span>
                                    </div>
                                    <div class="col-md-4 tasklists--wrapper__rating__points pr-0">
                                        <mat-form-field class="criteria-status dropdown" [class.selected]="criteria.updated_status">
                                        <span *ngIf="statusTemp"
                                              [class]="'criteria-status__icon ' + getStatus(criteria.default_status)"></span>
                                            <mat-select [(ngModel)]="criteria.updated_status" name="status"
                                                        [panelClass]="'matStatus'"
                                                        [disableOptionCentering]="true"
                                                        (ngModelChange)="updateStatus(criteria, LEVEL.criteria)"
                                                        class="criteria-status__filter__data">
                                                <mat-option *ngFor="let status of CRITERIA_STATUSES | keyvalue" [value]="status.value"
                                                            [class.hidden]="status.value === CRITERIA_STATUSES.partially_fullfilled || status.value === CRITERIA_STATUSES.review_assauge">
                                                    <span [class]="'criteria-status__icon ' + getStatus(criteria.default_status)"></span>
                                                    <span [class]="'criteria-status__label ' + status.key">{{ status.key | translate }}</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--    Criteria LEVEL    -->
        <div class="panel-heading col-md-12 tasklists--wrapper sticky interactive-tasks tasklists--wrapper--domain criteria-details" *ngIf="activeCriteria">
            <div class="tasklists--wrapper__header sticky" id="criteria-details-header">
                <i class="back fas fa-long-arrow-left col-md-2" (click)="setActiveCriteria(false);goBack(true)"></i>
                <div class="col-md-12 tasklists--wrapper__statement__label criteria-name">{{activeCriteria.criteria_letter}}. {{ activeCriteria['criteria_short_text_' + lang] }}</div>
                <div class="br-clear"></div>
            </div>
            <div class="container pull-left">
                <div class="row mr-t--sm">
                <span class="col-md-12">
                    {{ activeCriteria['criteria_ICD_text_' + lang] }}
                </span>
                </div>
                <ng-container *ngIf="activeCriteria.groups">
                    <div class="row mr-t--md" *ngFor="let group of activeCriteria.groups">
                        <div class="col-md-7 tasklists--wrapper__rating__list group-name">
                            <span [class]="'group-icon criteria-status__icon ' + getStatus(group.default_status)"></span>
                            <span class="group-text">
                            {{group['group_header_text_' + lang]}}
                        </span>
                        </div>
                        <div class="col-md-5 tasklists--wrapper__rating__points">
                            <mat-form-field class="criteria-status dropdown" [class.selected]="group.default_status">
                            <span *ngIf="statusTemp"
                                  [class]="'criteria-status__icon ' + getStatus(group.default_status)"></span>
                                <mat-select *ngIf="group.updated_status" [(ngModel)]="group.updated_status"
                                            [disableOptionCentering]="true"
                                            [panelClass]="'matStatus'"
                                            (ngModelChange)="updateStatus(group, LEVEL.group)"
                                            name="status" class="criteria-status__filter__data">
                                    <ng-container *ngFor="let status of CRITERIA_STATUSES | keyvalue">
                                        <mat-option [value]="status.value" [class.hidden]="status.value === CRITERIA_STATUSES.partially_fullfilled || status.value === CRITERIA_STATUSES.review_assauge">
                                            <span [class]="'criteria-status__icon ' + getStatus(group.default_status)"></span>
                                            <span [class]="'criteria-status__label ' + status.key">{{ status.key | translate }}</span>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
                <div class="row">
                    <div class="col-md-12 tasklists--wrapper__statement">
                        <ng-container *ngIf="activeCriteria.groups">
                            <div *ngFor="let group of activeCriteria.groups">
                                <div class="tasklists--wrapper__statement__label mr-t--md">
                                    <span>{{group['group_header_text_' + lang]}}</span>
                                    <span *ngIf="group['group_condition_text'] != undefined" class="tasklists--wrapper__statement__label__group_condition" [ngClass]="group['default_status'] === CRITERIA_STATUSES.fullfilled ?  'fullfilled' : 'unfullfilled' ">
                                    <span class="group-condition-icon" ></span>
                                    <span>{{group['group_condition_text']}} {{ group['group_condition_number']}}</span>
                                </span>
                                </div>
                                <ng-container *ngIf="group.type === GROUPTYPES.SYMPTOM && group.sub_groups.length">
                                    <div *ngFor="let subGroup of group.sub_groups">
                                        <div class="tasklists--wrapper__rating pt-0">
                                            <div class="tasklists--wrapper__rating__points mt-0"
                                                 (mouseover)="setHighlightSymptom($event, symptom)"
                                                 (mouseout)="unhighLightSymptom($event, false)"
                                                 *ngFor="let symptom of subGroup; let i = index">
                                                <feeling-list-selection 
                                                    [activeDomain]="activeDomain" 
                                                    [symptom]="symptom" 
                                                    [selectionList]="selectionList" 
                                                    [lang]="lang" 
                                                    [nodeClassList]="nodeClassList"
                                                    (changeRating)="updateRatingProposalDetail($event.activeDomain, $event.symptom, $event.position, $event.status, $event.isAnamnestic)" 
                                                    (changePrimary)="updatePrimary($event.feeling, $event.symptom)"
                                                    (changeActiveSymptom)="setActiveSymptom($event.symptom, $event.domain)">
                                                </feeling-list-selection>
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                        <div class="br-clear br-clear--bold"></div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="group.type === GROUPTYPES.TEXT">
                                    <span>{{group['group_body_text_' + lang]}}</span>
                                    <div class="clear"></div>
                                </ng-container>

                                <ng-container *ngIf="group.type === GROUPTYPES.CONDITIONS || group.exclude_diagnosis_code">
                                    <div class="tasklists--wrapper__rating pt-0" *ngIf="group.exclude_diagnosis_code">
                                        <div class="tasklists--wrapper__rating__points mt-0"
                                             *ngFor="let exclude of group.exclude_diagnosis_code; let i = index">
                                            <div class="col-md-11 pl-0 tasklists--wrapper__rating__list symptom-name exclude">
                                                <label>
                                                    {{'Does not have'| translate }} <b>{{ exclude.diagnoses_code }}</b>
                                                </label>
                                            </div>
                                            <div class="col-md-1 pl-0 tasklists--wrapper__rating__list warning-icon" *ngIf="exclude.selected">
                                                <i class="fas fa-exclamation-triangle"
                                                   aria-hidden="true"
                                                   [popover]="popTemplate"
                                                   [outsideClick]="true"
                                                   placement="left">
                                                </i>
                                                <ng-template #popTemplate>
                                                    <div class="exclude-popover">
                                                        <div class="exclude-popover__header">
                                                            <i class="fas fa-exclamation-triangle"></i>
                                                            <span>
                                                            {{'Does not have'| translate }} <b>{{ exclude.diagnoses_code }}</b>
                                                        </span>
                                                        </div>
                                                        <div class="exclude-popover__body">
                                                            {{'The following diagnosis exists and contradicts with the Kriteria for diagnosis'| translate }} {{ exclude.diagnoses_code }}
                                                        </div>
                                                        <ng-container *ngIf="exclude.have_relation">
                                                            <div class="exclude-popover__footer" (click)="goToProposal(exclude)">
                                                                <span>{{ 'Review' | translate }} {{ exclude.diagnoses_code }}</span>
                                                                <i class="fas fa-long-arrow-right"></i>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="br-clear"></div>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </ng-container>

                                <ng-container *ngIf="group.type === GROUPTYPES.EXCLUDE_SYMPTOM || group.exclude_symptom_code">
                                    <div class="tasklists--wrapper__rating pt-0" *ngIf="group.exclude_symptom_code">
                                        <div class="tasklists--wrapper__rating__points mt-0"
                                             *ngFor="let exclude of group.exclude_symptom_code; let i = index">
                                            <div class="col-md-11 pl-0 tasklists--wrapper__rating__list symptom-name exclude">
                                                <label>
                                                    {{'Does not have'| translate }} <b>{{ exclude['name_' + lang] }}</b>
                                                </label>
                                            </div>
                                            <div class="col-md-1 pl-0 tasklists--wrapper__rating__list warning-icon" *ngIf="exclude.selected">
                                                <i class="fas fa-exclamation-triangle"
                                                   aria-hidden="true"
                                                   [popover]="popTemplate"
                                                   [outsideClick]="true"
                                                   #pop="bs-popover"
                                                   placement="left">
                                                </i>
                                                <ng-template #popTemplate>
                                                    <div class="exclude-popover">
                                                        <div class="exclude-popover__header">
                                                            <i class="fas fa-exclamation-triangle"></i>
                                                            <span>
                                                            <b>{{ exclude['name_' + lang] }}</b>
                                                        </span>
                                                        </div>
                                                        <div class="exclude-popover__body">
                                                            {{'The following diagnosis exists and contradicts with the Kriteria for diagnosis'| translate }} {{ exclude.diagnoses_code }}
                                                        </div>
                                                        <ng-container>
                                                            <div class="exclude-popover__footer" (click)="goToSymptom(exclude, pop)">
                                                                <span>{{ 'Review' | translate }} {{ exclude['name_' + lang] }}</span>
                                                                <i class="fas fa-long-arrow-right"></i>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="br-clear"></div>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </ng-container>

                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </perfect-scrollbar>
</div>

<ng-template #filterTemplate let-extendFiltered="extendFiltered">
    <div class="row">
        <div class="col-md-12">
            <mat-form-field class="proposal--filter dropdown" [class.selected]="extendFiltered.domain">
                <mat-label *ngIf="!extendFiltered.domain" class="proposal--filter__label">{{ 'Domains' | translate }}</mat-label>
                <i *ngIf="extendFiltered.domain" class="fal fa-times proposal--filter__icon clear" (click)="extendFiltered.domain = null;$event.stopPropagation();setExtendFilters('domain');"></i>
                <mat-select  [(ngModel)]="extendFiltered.domain" (ngModelChange)="setExtendFilters('domain')" name="domain" class="proposal--filter__filter__data">
                    <mat-option *ngFor="let domain of extendFilters.domain" [value]="domain">
                        {{ domain['name_' + lang] }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="proposal--filter dropdown" [class.selected]="extendFiltered.icdChapter">
                <mat-label *ngIf="!extendFiltered.icdChapter" class="proposal--filter__label">{{ 'ICD Code' | translate }}</mat-label>
                <i *ngIf="extendFiltered.icdChapter" class="fal fa-times proposal--filter__icon clear" (click)="extendFiltered.icdChapter = '';$event.stopPropagation();setExtendFilters('icdChapter');"></i>
                <mat-select  [(ngModel)]="extendFiltered.icdChapter" (ngModelChange)="setExtendFilters('icdChapter')" name="icdChapter" class="proposal--filter__filter__data">
                    <mat-option *ngFor="let icd of extendFilters.icdChapter" [value]="icd" [class.hidden]="!icd">
                        {{ icd }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="proposal--filter dropdown" [class.selected]="extendFiltered.probability">
                <mat-label *ngIf="!extendFiltered.probability" class="proposal--filter__label">{{ 'Probability' | translate }}</mat-label>
                <i *ngIf="extendFiltered.probability" class="fal fa-times proposal--filter__icon clear" (click)="extendFiltered.probability = '';$event.stopPropagation();setExtendFilters('probability');"></i>
                <mat-select  [(ngModel)]="extendFiltered.probability" (ngModelChange)="setExtendFilters('probability')" name="probability" class="proposal--filter__filter__data">
                    <mat-option *ngFor="let probability of extendFilters.probability" [value]="probability.value">
                        {{ probability.name }}-{{ 'match' | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row" *ngIf="filteredProposals.length !== 0">
        <div class=" col-md-7 tasklists--wrapper__statement__label diagnosis-header">
            {{ 'Proposal diagnosis list' | translate }}
        </div>
        <div class=" col-md-5 tasklists--wrapper__statement__label diagnosis-header lblCollapse"
                (click)="isCriteriaCollapsed = !isCriteriaCollapsed">
                <span *ngIf="isCriteriaCollapsed">
                    <i class="fas fa-angle-down hidden"></i>{{ 'Expand criteria' | translate }}
                </span>
            <span *ngIf="!isCriteriaCollapsed">
                    <i class="fas fa-angle-up hidden"></i>{{ 'Collapse criteria' | translate }}
                </span>
        </div>
    </div>
</ng-template>
<ng-template #proposalBlock let-proposal="proposal">
    <div class="proposal-item" *ngIf="!proposal.hasOwnProperty('criterias')">
        <div class="row tasklists--wrapper__statement__label mb-0">
            <div class="col-md-8 diagnosis-name hover-n"
                 [isDisabled]="proposal.diagnoses.name_de_CH.length < 60 && proposal.diagnoses.name_en_GB.length < 60"
                 tooltip="{{ proposal.diagnoses['name_' + lang] }}" placement="top">
                {{ proposal.diagnoses['name_' + lang]}}
            </div>
            <div class="col-md-4 diagnosis-icon">
                <i tooltip="{{ 'Accept' | translate }}"
                   class="fal fa-check-circle diagnosis-icon--accept"
                   (click)="setActionProposal(proposal, PROPOSAL_ACTION.accept)"></i>
                <i tooltip="{{ 'Dismiss' | translate }}"
                   class=" fal fa-times-circle diagnosis-icon--dismiss"
                   (click)="setActionProposal(proposal, PROPOSAL_ACTION.dismiss)"></i>
            </div>
        </div>
        <div class="row pb-1">
            <div class="col-md-12 tasklists--wrapper__tags">
                <span>{{ 'No system info yet' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="proposal-item"
         [class.proposal-highlight]="lastAccessedProposalDiagnosis && lastAccessedProposalDiagnosis.id === proposal.id"
         *ngIf="proposal.hasOwnProperty('criterias')">
        <div class="row tasklists--wrapper__statement__label mb-0">
            <div class="col-md-8 diagnosis-name" (click)="setActiveDiagnosis(proposal)"
                 [isDisabled]="proposal.diagnoses.name_de_CH.length < 60 && proposal.diagnoses.name_en_GB.length < 60"
                 tooltip="{{proposal.diagnoses['name_' + lang] }}" placement="top">
                {{ proposal.diagnoses['name_' + lang] }}
            </div>
            <div class="col-md-4 diagnosis-icon">
                <i tooltip="{{ 'Highlight symptoms' | translate }}" containerClass="nowrap"
                   placement="bottom" class="fal diagnosis-icon--highlight"
                   [class.active]="proposal.highlight"
                   (click)="highlightDiagnosis(proposal)"></i>
                <i tooltip="{{ 'Accept' | translate }}" placement="bottom"
                   class="fal fa-check-circle diagnosis-icon--accept"
                   (click)="setActionProposal(proposal, PROPOSAL_ACTION.accept)"></i>
                <i tooltip="{{ 'Dismiss' | translate }}" placement="bottom"
                   class=" fal fa-times-circle diagnosis-icon--dismiss"
                   (click)="setActionProposal(proposal, PROPOSAL_ACTION.dismiss)"></i>
            </div>
            <div class="col-md-12">
                <span class="diagnosis-code">{{proposal.diagnoses.code}} </span>
                <span class="percentage percentage--from">{{ld.parseInt(proposal.percentage.from)}}%</span>
                <span class="percentage"
                      *ngIf="proposal.percentage.from != proposal.percentage.to"> - {{ld.parseInt(proposal.percentage.to)}}%</span>
                <span class="progress-bar">
                        <span class="progress-bar__percentage"
                              [style.width]="(100 - ld.parseInt(proposal.percentage.from))*0.8 + 'px'"></span>
                    </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 tasklists--wrapper__tags">
                    <span *ngFor="let domain of proposal.related_domain">
                      {{domain['name_' + lang]}}
                    </span>
            </div>
            <div *ngIf="proposal.criterias.length"
                 class="col-md-12 tasklists--wrapper__statement"
                 [class.animate-marked]="proposal['passed']">
                <div class="tasklists--wrapper__rating tasklists--wrapper__rating--criterialevel pt-0"
                     *ngIf="!isCriteriaCollapsed">
                    <div class="tasklists--wrapper__rating__points item-block mt-0"
                         [class.animate-marked]="criteria['passed']"
                         *ngFor="let criteria of proposal.criterias; let i = index">
                        <ng-container *ngIf="criteria.id">
                            <div (click)="setActiveCriteria(criteria)"
                                 class="col-md-8 pl-0 tasklists--wrapper__rating__list symptom-name">
                                    <span>
                                        {{criteria.criteria_letter}}. {{criteria['criteria_short_text_' + lang]}}
                                    </span>
                            </div>
                            <div class="col-md-4 pr-0">
                                <mat-form-field class="criteria-status dropdown"
                                                [class.selected]="criteria.default_status">
                                <span *ngIf="criteria.default_status"
                                      [class]="'criteria-status__icon ' + getStatus(criteria.default_status)"></span>
                                    <mat-select *ngIf="criteria.updated_status"
                                                [disableOptionCentering]="true"
                                                [(ngModel)]="criteria.updated_status"
                                                name="status"
                                                (ngModelChange)="updateStatus(criteria, LEVEL.criteria)"
                                                [panelClass]="'matStatus'"
                                                class="criteria-status__filter__data">
                                        <ng-container
                                                *ngFor="let status of CRITERIA_STATUSES | keyvalue">
                                            <mat-option [value]="status.value"
                                                        [class.hidden]="status.value === CRITERIA_STATUSES.partially_fullfilled || status.value === CRITERIA_STATUSES.review_assauge">
                                                <span [class]="'criteria-status__icon ' + getStatus(criteria.default_status)"></span>
                                                <span [class]="'criteria-status__label ' + status.key">{{ status.key | translate}}</span>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<dialog-component #dialog></dialog-component>